"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Accordion = _interopRequireDefault(require("../../../components/accordion/Accordion"));

var _BestLabel = _interopRequireDefault(require("../elements/BestLabel"));

var _LabelFormatter = _interopRequireDefault(require("./LabelFormatter"));

var _FormatterHelper = require("../../../components/helpers/FormatterHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FileAttachmentsMobile = function FileAttachmentsMobile(_ref) {
  var data = _ref.data,
      customActionButton = _ref.customActionButton;
  var DeleteFormatter = (0, _FormatterHelper.getFormatter)(customActionButton, data);
  return _react["default"].createElement(_Accordion["default"], null, _react["default"].createElement(_Accordion["default"].Header, {
    hasCustomActionButton: true,
    customActionButton: DeleteFormatter,
    color: "#f7f7f7"
  }, _react["default"].createElement("div", null, data.fileName, _react["default"].createElement("div", null, _react["default"].createElement(_BestLabel["default"], {
    htmlFor: "fileAttachment"
  }, "Label"), _react["default"].createElement(_LabelFormatter["default"], {
    value: data.labels,
    name: "fileAttachment"
  })))), _react["default"].createElement(_Accordion["default"].Body, null));
};

FileAttachmentsMobile.propTypes = {
  data: _propTypes["default"].object.isRequired,
  customActionButton: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].object]).isRequired
};
FileAttachmentsMobile.defaultProps = {};
var _default = FileAttachmentsMobile;
exports["default"] = _default;